"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _utils = require("@/utils");
var _Carousel = _interopRequireDefault(require("@/ui/components/carousel/Carousel"));
var _UserList = _interopRequireDefault(require("@/ui/components/UserList"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var trackOne = 'https://upload.wikimedia.org/wikipedia/en/4/45/ACDC_-_Back_In_Black-sample.ogg';
var _default2 = exports.default = {
  name: 'ModalOccurrence',
  components: {
    Carousel: _Carousel.default,
    UserList: _UserList.default
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    closedNewService: {
      type: Function,
      default: function _default() {}
    },
    activities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    resolvedCalback: {
      type: Function,
      default: function _default() {}
    },
    occurrenceSelected: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    occurrenceTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showModalItem: false,
      edit: false,
      comment: '',
      erroCommnet: false,
      errors: [],
      track: trackOne,
      ocurrence: {
        coordinatorId: null
      },
      logs: [],
      listCoordinators: []
    };
  },
  mounted: function mounted() {
    this.showModalItem = this.showModal;
    this.$watch('track', function () {
      this.$refs.player.load();
    });
  },
  created: function created() {
    this.ocurrence = _.cloneDeep(this.occurrenceSelected);
    this.getLogs(this.ocurrence);
    this.getCoordinators();
  },
  computed: {
    verifyEdit: function verifyEdit() {
      var compare = JSON.stringify(this.ocurrence) === JSON.stringify(this.occurrenceSelected) && this.edit === false;
      return !compare;
    },
    listTypes: function listTypes() {
      if (!this.occurrenceTypes.length) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.occurrenceTypes.sort(function (a, b) {
        return (0, _utils.removeAccents)(a.name.toLowerCase()).localeCompare((0, _utils.removeAccents)(b.name.toLowerCase()));
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getOcurrencesLogsRest', 'saveOccurrence', 'setLoading', 'fetchUsers'])), {}, {
    closedModalItem: function closedModalItem() {
      this.errors = [];
      this.$emit('closedModal');
    },
    userName: function userName(user) {
      if (!user) return 'Coordenador';
      return user.firstName;
    },
    getLogs: function () {
      var _getLogs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var self, response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              self = this;
              self.setLoading();
              _context.p = 1;
              _context.n = 2;
              return this.getOcurrencesLogsRest(item.id);
            case 2:
              response = _context.v;
              self.logs = response;
              self.setLoading(false);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              self.logs = [];
              self.setLoading(false);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getLogs(_x) {
        return _getLogs.apply(this, arguments);
      }
      return getLogs;
    }(),
    getCoordinators: function () {
      var _getCoordinators = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.fetchUsers({
                roleId: 3,
                activated: true
              });
            case 1:
              data = _context2.v;
              if (data) {
                this.listCoordinators = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getCoordinators() {
        return _getCoordinators.apply(this, arguments);
      }
      return getCoordinators;
    }(),
    onInsertComment: function onInsertComment(e) {
      var comment = this.comment.trim();
      if (comment && comment.length >= 10) {
        this.erroCommnet = false;
        var item = {
          date: (0, _moment.default)().format(),
          comment: comment,
          userId: this.ocurrence.user.id
        };
        if (!this.logs) this.logs = [];
        this.logs.push(item);
        comment = '';
        var commnets = this.logs;
        this.logs = commnets.sort((0, _utils.sortBy)('date'));
        this.comment = '';
        if (!this.edit) this.edit = true;
      } else {
        if (e.type !== 'blur') this.erroCommnet = true;
      }
    },
    verifySave: function verifySave() {
      var aprove = true;
      var msg = '';
      if (!this.ocurrence.status || this.ocurrence.status === null || this.ocurrence.status === '') {
        aprove = false;
        msg = 'Por favor, selecione um status para a ocorrência!';
      }
      if (msg) {
        this.$buefy.toast.open({
          duration: 3000,
          message: msg,
          type: 'is-danger'
        });
      }
      return aprove;
    },
    saveItens: function () {
      var _saveItens = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var payload, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.verifySave()) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, false);
            case 1:
              payload = {
                occurrence: this.ocurrence,
                logs: this.logs
              };
              _context3.n = 2;
              return this.saveOccurrence(payload);
            case 2:
              data = _context3.v;
              if (data) this.$emit('closedModal', 'reload');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveItens() {
        return _saveItens.apply(this, arguments);
      }
      return saveItens;
    }(),
    getImages: function getImages(objImages) {
      var images = [];
      objImages.forEach(function (image) {
        var obj = null;
        try {
          obj = JSON.parse(image);
        } catch (error) {
          obj = null;
        }
        if (!obj && (typeof image === 'string' || image instanceof String)) {
          images.push(image);
        } else {
          images.push(obj.image);
        }
      });
      return images;
    }
  })
};